import { NameDto } from '../../Common/Types'
import { SubscriptionRequestCancellationStatusValueType } from './SubscriptionRequestCancellationStatus'

export interface UnsubscribeRequestDto {
  id: string
  reference: string
  description: string
  client: NameDto<string>
  subscriptionName: string
  country: NameDto<string>
  status: NameDto
  tickmillCompany: NameDto
  createdDate: string
  updatedDate: string
  selected: boolean
}

export enum UnsubscribeRequestKey {
  reference = 'reference',
  description = 'description',

  client = 'client.name',
  subscriptionName = 'subscriptionName',
  country = 'country.name',
  status = 'status.name',
  tickmillCompany = 'tickmillCompany.name',
  createdDate = 'createdDate',
  updatedDate = 'updatedDate',
}

export enum UnsubscribeRequestFilterKey {
  reference = 'Reference',
  description = 'Description',
  client = 'ClientId',
  subscriptionName = 'SubscriptionName',
  country = 'Country',
  status = 'StatusId',
  company = 'TickmillCompanyId',
  createdDate = 'DateCreated',
  updatedDate = 'DateUpdated',
}

export interface EditUnsubscribeRequestDto {
  description: string
  status: SubscriptionRequestCancellationStatusValueType
}

export interface EditUnsubscribeRequestsDto {
  ids: string[]
}
